import React from 'react'
import PropTypes from 'prop-types'

import { LinkView } from 'Components/Link/View'
import { LinkEdit } from 'Components/Link/Edit'

/**
 *
 * @param {*} props.title e.g. {props.campaign.name || ''}
 * @param {*} props.subTitle e.g. {props.campaign.client.name}
 * @param {*} props.description
 * @param {*} props.footer e.g. {props.campaign.type}
 */
const CampaignCardUnstyled = props => (
  <div className={props.className}>
    <div onClick={props.onClick && props.onClick.bind(null, props.campaign)}>
      <div className="name">
        <div className={'campaign-status'} />
        <img src={props.img || ''} alt="logo" />
        <div className={'campaign-name'}>{props.title}</div>
        <div className={'client-name'}>{props.subTitle}</div>
      </div>
      <div className="duration-archived-company">{props.campaignTimeRange}</div>
      <div className="number-of-cities">{props.description}</div>
      <div className="number-of-cities">{props.footer}</div>
    </div>
    {props.viewPath && props.editPath && (
      <div className="actions">
        <LinkView to={props.viewPath} label="View" />
        <LinkEdit to={props.editPath} label="Edit" />
      </div>
    )}
  </div>
)
CampaignCardUnstyled.propTypes = {
  viewPath: PropTypes.string,
  editPath: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  campaign: PropTypes.shape({
    name: PropTypes.string,
    cities: PropTypes.array,
    client: PropTypes.shape({
      logo: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
  }).isRequired,
}

export { CampaignCardUnstyled }



// WEBPACK FOOTER //
// ./src/Components/Campaigns/CampaignCard/unstyled.js